import { SongHistoryStore } from "@/types"
import Dexie, { EntityTable } from "dexie"

// Docs: https://dexie.org/docs/Tutorial/Vue
// https://dexie.org/docs/API-Reference#query-items
const songsDB = new Dexie('songsDB') as Dexie & {
  streamers: EntityTable<
    SongHistoryStore,
    'channel' // primary key "channel" (for the typings only)
  >;
};

// Schema declaration:
songsDB.version(1).stores({
  streamers: 'channel' // primary key "channel" (for the runtime!)
})

export { songsDB }